import React, { Component } from 'react';
import Head from 'next/head';
import axios from 'axios';
import Thanks from './../../../components/Thanks';
import { Input, Textarea } from './../../../components/forms/input';
import ReCAPTCHA from 'react-google-recaptcha';
const NEXT_PUBLIC_RECAPTCHA_SITE_KEY = '6Le-UtseAAAAAGpB4ucUJNIvZslgvZXc77lRT3tG';

class PPCGetProposal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formdata: {},
      showThanks: false,
      loadedThanks: false,
      website: '',
    };
    this.reRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.hideThanksModal = this.hideThanksModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  handleChange(param, value) {
    this.setState(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
  }
  hideThanksModal() {
    this.setState({
      loadedThanks: false,
      showThanks: false,
      website: '',
    });
    document.body.style.overflow = 'auto';

    document.body.style.overflowX = 'hidden';
    location.reload();
  }
  onSubmit(e) {
    e.preventDefault();

    const token = this.reRef.current.getValue();
    if (token) {
      let form_data = new FormData(e.target);
      for (let key in this.state.formdata) {
        form_data.append(key, this.state.formdata[key]);
      }
      form_data.append('country', this.props.country);
      form_data.append('service', 'Paid Advertising');

      document.body.style.overflow = 'hidden';

      axios.post('https://mailer.weprodigi.com/api/v1/get-proposal', form_data).then(response => {
        window.location.href = 'https://weprodigi.com/thank-you';
      });
    }
    this.reRef.current.reset();
  }
  componentDidMount() {
    this.setState({ website: new URL(location.href).searchParams.get('website') });
  }
  render() {
    return (
      <>
        <Head>
          <title>Paid Ad Services Request Form - Get a Proposal | WeProdigi</title>
          <link rel="alternate" hrefLang="en" href="https://weprodigi.com/paid-advertising-services/get-proposal" />
          <meta
            name="description"
            content="Request a customized proposal for our paid advertising services. Achieve your marketing goals with targeted ad strategies from Prodigi."
          />
          <meta property="og:url" content="https://weprodigi.com/paid-advertising-services/get-proposal" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Paid Ad Services Request Form - Get a Proposal | WeProdigi" />
          <meta
            property="og:description"
            content="Request a customized proposal for our paid advertising services. Achieve your marketing goals with targeted ad strategies from Prodigi."
          />
        </Head>
        <style global jsx>{`
          .bg-image {
            background-size: cover;
            background-image: url('/images/about/main-image-positions.png');
            background-position: center;
          }
        `}</style>
        <div className="relative w-full  h-300  overflow-hidden  bg-grid">
          <div className="container h-full">
            <div className="relative h-full  flex flex-col flex-wrap justify-center items-start ">
              <h1 className="uppercase text-purple text-36 md:text-72 font-black leading-none">
                get
                <span className="block leading-[108px]">proposal</span>
              </h1>

              <div className="text-black text-24 md:text-36 font-black mt-10 max-w-450 uppercase"> paid advertising </div>
            </div>
          </div>
        </div>
        <div className="bg-white py-30">
          <div className="container">
            <form method="POST" onSubmit={e => this.onSubmit(e)}>
              <div className="mt-20">
                <div className="mb-10">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                    <div>
                      <p className="text-14 mb-5 text-purple font-bolder">Company Name*</p>
                      <div className="mb-10">
                        <Input type="text" name="company-name" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                    <div>
                      <p className="text-14 mb-5 text-purple font-bolder">Company Website*</p>
                      <div className="mb-10">
                        <input
                          type="text"
                          name="website"
                          bg="bg-gray-light"
                          className={'w-full bg-gray-light rounded-5 pl-15 py-5'}
                          required={false}
                          onChange={this.handleChange}
                          defaultValue={this.state.website}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-10">
                  <p className="text-14 mb-5 text-purple font-bolder">Describe Your Project</p>
                  <div className="mb-10">
                    <Textarea
                      type="text"
                      name="description"
                      bg="bg-gray-light resize-none"
                      required={false}
                      rows={4}
                      placeholder=""
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="mb-10">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                    <div>
                      <p className="text-14 mb-5 text-purple font-bolder">Your Name *</p>
                      <div className="mb-10">
                        <Input type="text" name="name" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                    <div>
                      <p className="text-14 mb-5 text-purple font-bolder">Your Email *</p>
                      <div className="mb-10">
                        <Input type="text" name="email" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                    <div>
                      <p className="text-14 mb-5 text-purple font-bolder">Your Phone Number *</p>
                      <div className="mb-10">
                        <Input type="number" name="phone-number" bg="bg-gray-light" required={true} onChange={this.handleChange} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col my-10">
                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-black text-14 md:text-18 flex items-center">
                      <input
                        id="nda"
                        className="absolute cursor-pointer opacity-0"
                        onChange={e => this.handleChange('nda', e.target.checked ? 'yes' : 'No')}
                        type="checkbox"
                        name="nda"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-black rounded-sm" />
                      Send NDA
                    </label>
                  </div>
                  <div className="flex flex-row my-10">
                    <ReCAPTCHA sitekey={NEXT_PUBLIC_RECAPTCHA_SITE_KEY} size={'normal'} ref={this.reRef} />
                  </div>
                </div>
                <input type="hidden" name="country" value={this.props.country} />
                <div className="col-span-2">
                  <button
                    id="offer-submit"
                    type="submit"
                    className="cursor-pointer mx-auto text-white bg-green text-18 mt-10 px-23 py-3 rounded-5 block "
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Thanks show={this.state.showThanks} loaded={this.state.loadedThanks} hide={this.hideThanksModal}>
          Thank you for reaching out to us! One of our account managers will contact you and confirm your request. If you don’t receive an email from
          us within 24 hours please check your Spam Box.
        </Thanks>
      </>
    );
  }
}
export default PPCGetProposal;
